import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { AjaxService } from '../services/ajax.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { UserService } from '../services/user.service';


@Component({
  selector: 'app-signup',
  standalone: true,
  imports: [RouterLink, ReactiveFormsModule],
  templateUrl: './signup.component.html',
  styleUrl: './signup.component.scss'
})
export class SignupComponent {

  constructor (private _ajaxService : AjaxService, private _bar : MatSnackBar, private _userServices : UserService, private _router : Router) {}

  signUpForm = new FormGroup({
    firstName : new FormControl('', [Validators.required, this.noWhitespaceValidator()]),
    lastName : new FormControl('', [Validators.required, this.noWhitespaceValidator()]),
    schoolName : new FormControl('', [Validators.required, this.noWhitespaceValidator()]),
    email: new FormControl('', [Validators.required, Validators.email, this.noWhitespaceValidator()]),
    password: new FormControl('', [Validators.required, this.noWhitespaceValidator()]),
  });

  submitted = false;

  get f() { return this.signUpForm.controls; }

  noWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const isWhitespace = (control.value || '').trim().length === 0;
      const isValid = !isWhitespace;
      return isValid ? null : { 'whitespace': true };
    };
  }
  
  onSubmit() {
    this.submitted = true
    if (this.signUpForm.valid) {
      const request = {
        "firstName" : this.signUpForm.value.firstName?.trim(),
        "lastName" : this.signUpForm.value.lastName?.trim(),
        "email" : this.signUpForm.value.email?.trim(),
        "role" : "PRINCIPLE",
        "password" : this.signUpForm.value.password?.trim(),
        "schoolName" : this.signUpForm.value.schoolName?.trim()
      }
      this._ajaxService.post("users/register", request).then((response: any) => {
        this._router.navigate(['/'])
      })
      .catch(error => {
        this._bar.open(`${error.error.message}`, "OK", { duration: 3000, panelClass: "error-dialog" })
      })
    }
  }
}
